module.exports = __webpack_public_path__ + "img/linkedin.4803894f.svg";